import { useQuery } from 'react-query'

import Deserializer from '~/services/Deserializer'
import EmpriseGroup from '~/services/EmpriseGroup'

import { CACHE_KEYS } from '~/constants'

const deserializeResult = async (resp) => {
  const articles = await Deserializer.deserialize(resp?.articles)

  return { articles, pagy: resp?.pagy }
}

const promiseAllSequential = (functions) =>
  functions.reduce(
    (promise, func) =>
      promise.then((result) =>
        func().then(Array.prototype.concat.bind(result))
      ),
    Promise.resolve([])
  )

export const blogRequest = () =>
  promiseAllSequential([
    () =>
      EmpriseGroup.getBlogArticles({
        byCategory: 'Reviews',
        limit: 3
      }).then((resp) => deserializeResult(resp)),
    () =>
      EmpriseGroup.getBlogArticles({
        byCategory: 'Destinations',
        limit: 4
      }).then((resp) => deserializeResult(resp)),
    () =>
      EmpriseGroup.getBlogArticles({
        byCategory: 'News',
        limit: 3
      }).then((resp) => deserializeResult(resp)),
    () =>
      EmpriseGroup.getBlogArticles({ featured: true, limit: 4 }).then((resp) =>
        deserializeResult(resp)
      )
  ])

const useIndexBlog = () => {
  const state = useQuery(CACHE_KEYS.newsReviews, blogRequest, {
    refetchOnWindowFocus: false
  })

  return state
}

export default useIndexBlog
